import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { PrismicColor } from "utils";

import {
  AspectRatio,
  Box,
  Button,
  Column,
  Columns,
  Flex,
  Heading,
  Link,
  RichText,
  VStack,
  Wrapper,
} from "components";

function TextSplit({
  title,
  content,
  button_label,
  button_link,
  color,
  decreasePadding,
}) {
  return (
    <Flex
      id={title && title.text}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      bg={color}
      css={{
        transform: "skew(0, -4deg)",
      }}
    >
      <Box
        py={{ _: "layout.5", lg: decreasePadding ? "layout.0" : "layout.5" }}
        px={{ _: "layout.3", lg: "layout.5" }}
        css={{
          transform: "skew(0, 4deg)",
        }}
      >
        <VStack space="layout.2">
          {title && title.text && (
            <Heading
              children={title.text}
              size={700}
              maxWidth={decreasePadding ? "20ch" : "16ch"}
            />
          )}
          {content && content.html && (
            <RichText
              html={content.html}
              size={500}
              maxWidth={decreasePadding ? "36ch" : "32ch"}
            />
          )}
          {button_link && button_link.url && button_label && (
            <Link href={button_link.url}>
              <Button
                children={button_label}
                intent="primary"
                appearance="primary"
                round={true}
              />
            </Link>
          )}
        </VStack>
      </Box>
    </Flex>
  );
}

export function ImageTextSplit({
  button_label,
  button_link,
  color,
  content,
  image,
  invert,
  title,
  background,
}) {
  // If the background color is the same color as the TextSplit color, then
  // set lower padding to avoid unnatural centering
  const DECREASE_PADDING = color === background ? true : false;

  if (title && title.text && content && content.html)
    return (
      <Wrapper
        px={{ _: 0, md: "layout.4", lg: "layout.5" }}
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Columns flexDirection={invert ? "row" : "row-reverse"}>
          <Column width={{ _: 1, lg: 1 / 2 }}>
            {image && image.gatsbyImageData && (
              <AspectRatio ratio="3:2">
                <GatsbyImage
                  image={getImage(image.gatsbyImageData)}
                  alt={image.alt || ""}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    transform: "skew(0, -4deg)",
                  }}
                  imgStyle={{ objectFit: "cover", objectPosition: "50% 50%" }}
                />
              </AspectRatio>
            )}
          </Column>
          <Column width={{ _: 1, lg: 1 / 2 }}>
            <TextSplit
              title={title}
              content={content}
              button_label={button_label}
              button_link={button_link}
              color={PrismicColor(color)}
              decreasePadding={DECREASE_PADDING}
            />
          </Column>
        </Columns>
      </Wrapper>
    );
  else return null;
}
